// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

export const version = '5.5.0'
export const publishDates = {
	major: '2026-05-06T16:28:18.473Z',
	minor: '2026-09-30T12:01:53.618Z',
	patch: '2026-09-30T12:01:53.618Z',
}
